import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScaleService {

  private URL = "http://10.0.0.227:8085";

  constructor(private http: HttpClient) { }

  getScalesValue(scaleId: any) {
    return this.http.get(this.URL + `/weight/${scaleId}`);
  }

  getHealth() {
    return this.http.get(this.URL + `/health`);
  }
}
